import { Visibility } from '@mui/icons-material';
import {
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import React from 'react';

const getActionColor = (action) => {
  switch (action) {
    case 'INSERT':
      return 'success';
    case 'UPDATE':
      return 'warning';
    case 'DELETE':
      return 'error';
    default:
      return 'default';
  }
};

const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString();
};

export default function ChangeLogsTable({ logs, loading, onViewDetails }) {
  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Paper sx={{ overflow: 'auto' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Table</TableCell>
            <TableCell>Record ID</TableCell>
            <TableCell>Action</TableCell>
            <TableCell>Changed By</TableCell>
            <TableCell>Source</TableCell>
            <TableCell>Created At</TableCell>
            <TableCell align="right">Details</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {logs.map((log) => (
            <TableRow key={log.id}>
              <TableCell>{log.id}</TableCell>
              <TableCell>{log.table_name}</TableCell>
              <TableCell>{log.record_id}</TableCell>
              <TableCell>
                <Chip
                  label={log.action}
                  color={getActionColor(log.action)}
                  size="small"
                />
              </TableCell>
              <TableCell>{log.changed_by || '-'}</TableCell>
              <TableCell>{log.change_source}</TableCell>
              <TableCell>{formatDate(log.created_at)}</TableCell>
              <TableCell align="right">
                <IconButton color="primary" onClick={() => onViewDetails(log)}>
                  <Visibility />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          {logs.length === 0 && !loading && (
            <TableRow>
              <TableCell colSpan={8} align="center">
                No change logs found.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}
